var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v(" Feature Name: "),_c('input',{ref:"featureName",attrs:{"type":"text"},domProps:{"value":_vm.feature.name},on:{"change":_vm.changeName}})])])}
var staticRenderFns = []

export { render, staticRenderFns }